<template>
  <div class="rubric-library-cards">
    <component
      :is="rubricComponent"
      v-for="rubric in rubrics"
      :key="rubric.id"
      :selected-rubric="rubric"
      :is-selected="rubric.id === value?.id"
      :is-platform-rubric="isPlatformRubric"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import EgRubricCard from "@/components/rubrics/components/eg_rubric_card.vue";
import EssayRubricSelect from "@/components/dashboard/components/essay_rubric_select.vue";

export default {
  name: "RubricLibraryViewList",

  components: {
    EgRubricCard,
    EssayRubricSelect,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    rubrics: {
      type: Array,
      default: () => [],
    },
    isPlatformRubric: {
      type: Boolean,
      default: false,
    },
    isRubricCard: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["selectRubric"],

  computed: {
    rubricComponent() {
      return this.isRubricCard ? "EgRubricCard" : "EssayRubricSelect";
    },
  },
};
</script>

<style lang="scss" scoped></style>
